import PropTypes from 'prop-types';
import { spacingPropTypes, } from '../../interfaces/layoutProps';
export const formHelperTextVariants = ['hint', 'invalid'];
export const formHelperTextPropTypes = {
    children: PropTypes.node.isRequired,
    disabled: PropTypes.bool,
    variant: PropTypes.oneOf(formHelperTextVariants),
    ...spacingPropTypes,
};
//# sourceMappingURL=FormHelperText.types.js.map